import { c as _c } from "react/compiler-runtime";
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import DesktopHeader from '../../../components/desktop-header';
import IdDocAnimation from '../../../components/id-doc-animation';
import Loading from '../../../components/loading';
import RetryLimitExceeded from '../../../components/retry-limit-exceeded';
import Success from '../../../components/success';
type DesktopProcessingViewProps = {
  mode: 'loading' | 'success';
  step: 'upload' | 'analyze';
  showSlowConnectionMessage: boolean;
  retryLimitExceeded: boolean;
  isMissingRequirements: boolean;
  docName: string;
  sideName: string;
  isSelfie: boolean;
  country: Iso3166TwoDigitCountryCode | undefined;
  docType: string | undefined;
  currSide: string | undefined;
  onRetryLimitExceeded: () => void;
  onNextStep: () => void;
};
const DesktopProcessingView = t0 => {
  const $ = _c(30);
  const {
    mode,
    step,
    showSlowConnectionMessage,
    retryLimitExceeded,
    isMissingRequirements,
    docName,
    sideName,
    isSelfie,
    country,
    docType,
    currSide,
    onRetryLimitExceeded,
    onNextStep
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-processing"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isMissingRequirements) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <p className="text-label-1 text-error text-center fp-text">{t2}</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (retryLimitExceeded) {
    let t2;
    if ($[5] !== onRetryLimitExceeded) {
      t2 = <RetryLimitExceeded onRetryLimitExceeded={onRetryLimitExceeded} />;
      $[5] = onRetryLimitExceeded;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (!docType || !currSide) {
    return null;
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = isSelfie ? undefined : docName;
  let t4;
  if ($[8] !== country || $[9] !== isSelfie || $[10] !== sideName || $[11] !== t3) {
    t4 = <DesktopHeader docName={t3} country={country} sideName={sideName} isSelfie={isSelfie} />;
    $[8] = country;
    $[9] = isSelfie;
    $[10] = sideName;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== showSlowConnectionMessage || $[14] !== step) {
    t5 = <Loading step={step} showSlowConnectionMessage={showSlowConnectionMessage} />;
    $[13] = showSlowConnectionMessage;
    $[14] = step;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Success />;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== mode || $[18] !== t5) {
    t7 = <div className="flex flex-col justify-center items-center bg-secondary border border-dashed border-primary rounded min-h-[280px]"><IdDocAnimation loadingComponent={t5} successComponent={t6} mode={mode} hasNextSide={false} /></div>;
    $[17] = mode;
    $[18] = t5;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = mode === "loading";
  let t9;
  if ($[20] !== t) {
    t9 = t(_temp2);
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onNextStep || $[23] !== t8 || $[24] !== t9) {
    t10 = <Button fullWidth={true} disabled={t8} onClick={onNextStep} size="large" data-dd-action-name="doc:continue">{t9}</Button>;
    $[22] = onNextStep;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t4 || $[28] !== t7) {
    t11 = <div className="flex flex-col gap-6 max-md:px-2">{t2}{t4}{t7}{t10}</div>;
    $[26] = t10;
    $[27] = t4;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
export default DesktopProcessingView;
function _temp($) {
  return $["missing-requirement-error"];
}
function _temp2($_0) {
  return $_0.continue;
}